import { ComponentPropsWithoutRef, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { newTabReceiveData } from "utils/newTab";
import PrintLayout from "../../components/print-layout/PrintLayout";
import type { TNotesType } from "../../types";

type ReceivedData = Exclude<
  ComponentPropsWithoutRef<typeof PrintLayout>,
  "error" | "type"
>;

const Print = () => {
  const { type } = useParams<{ type: TNotesType }>();

  const [error, setError] = useState<any>();

  const [receivedData, setReceivedData] = useState<ReceivedData>();

  useEffect(() => {
    // try receiving the data
    newTabReceiveData<ReceivedData>()
      .then((res) => {
        setReceivedData(res);
      })
      .catch(setError);
  }, []);

  return !receivedData || !type ? null : (
    <PrintLayout {...receivedData} error={error} type={type} />
  );
};

export default Print;
